export const SUPPORT_TYPE_PROPERTY_GID = 'a4a564cf-4d38-4e5f-8ce7-1e364cf7c3ab' // Тип обращения
export const DOCS_TYPE_PROPERTY_GID = '48d954fb-2850-4602-9be8-a94cd0795f6d' // Тип обращения документооборота
export const PRODUCT_PROPERTY_GID = 'c69d90d8-d474-4a88-aac9-fbe728eb35cd' // Продукт
export const TELEGRAM_PROPERTY_OPTION_GID = '3e287173-1b0f-4504-85f5-b4d5093588c6' // Премодерация канала/бота в Telegram
